<template>
  <body class="px-4 lg:px-20">
    <div class="container mx-auto">
      <div
        class="
          flex flex-col
          lg:flex-row
          justify-center
          items-center
          py-12
          mx-4
          md:mx-6
        "
      >
        <div
          class="
            lg:w-1/2
            flex flex-col
            justify-center
            items-center
            lg:items-start
          "
        >
          <h1
            class="
              text-3xl
              lg:text-4xl
              xl:text-5xl
              font-bold
              text-gray-800 text-center
              lg:text-left
            "
          >
            Meet our Clients
          </h1>
          <p
            class="
              text-base
              leading-normal
              text-gray-600
              mt-4
              md:w-8/12
              lg:w-11/12
              text-center
              lg:text-left
            "
          >
            We have worked with different kinds of companies from across the land on different types of 
            construction and fabrication projects over the span of time since our establishment.
          </p>
         
        </div>
        <div
          role="list"
          aria-label="Team members"
          class="
            lg:w-1/2
            grid grid-cols-3
            sm:grid-cols-3
            md:grid-cols-4
            gap-x-12 gap-y-12
            md:gap-x-12
            mt-10
            lg:mt-0
            sm:w-auto
            w-full
          "
        >
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/dg.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/mc.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/pg.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/ross.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/wwf.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/x.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/x.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/x.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/x.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/x.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/x.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/x.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/x.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/x.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
          <div role="listitem" class="flex justify-center items-center">
            <img
              src="@/images/x.png"
              class="w-16 h-16"
              alt="display avatar"
              role="img"
            />
          </div>
         
         
         
          
         
        </div>
      </div>
    </div>
  </body>
</template>

<script>
export default {
  name: "Clients",
  data() {
    return {};
  },
};
</script> 

<style scoped>
</style>
